import React from 'react';
import { Button as ChakraButton, Icon, forwardRef } from '@chakra-ui/react';
import Children from 'react-children-utilities';
import { isNil, reject } from 'ramda';
import { Spinner } from '../spinner';
export const Button = forwardRef((props, ref)=>{
    const { children , size , leftIcon: LeftIcon , rightIcon: RightIcon , ...buttonProps } = props;
    const label = Children.onlyText(children);
    const iconSize = size === 's' ? '18px' : '24px';
    const iconProps = reject(isNil, {
        leftIcon: LeftIcon && /*#__PURE__*/ React.createElement(Icon, {
            as: LeftIcon,
            boxSize: iconSize
        }),
        rightIcon: RightIcon && /*#__PURE__*/ React.createElement(Icon, {
            as: RightIcon,
            boxSize: iconSize
        })
    });
    return /*#__PURE__*/ React.createElement(ChakraButton, {
        loadingText: label,
        ref: ref,
        size: size,
        spinner: /*#__PURE__*/ React.createElement(Spinner, {
            size: Number.parseInt(iconSize)
        }),
        spinnerPlacement: "end",
        ...iconProps,
        ...buttonProps
    }, label);
});

//# sourceMappingURL=button.js.map